import { Component, Input, OnInit } from '@angular/core';

@Component({
	selector: 'bb-floating-label',
	templateUrl: './bb-floating-label.component.html',
	styleUrls: ['./bb-floating-label.component.scss']
})
export class BbFloatingLabelComponent implements OnInit {
	@Input() label?: string;
	@Input() theme?: string = '';
	@Input() active = false;

	/**
	 * Use any <input> as <ng-content>
	 * Will put a floating label above the input field with a border around the component
	 */
	constructor() { }

	ngOnInit(): void {
	}

}
